var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-gray2 pb-2" },
    [
      _c(
        "ob1-liens-haut-bas",
        {
          staticClass: "container-fluid py-2",
          attrs: {
            "button-id": "legal-mentions-header",
            "collapsed-block-id": "legal-mentions-text",
            "button-label": _vm.title,
          },
        },
        [
          _vm.pxfLegalMentionsText
            ? _c("div", [
                _c("div", {
                  staticClass: "fw-bold small",
                  domProps: { innerHTML: _vm._s(_vm.pxfLegalMentionsText) },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.cb4xLegalMentionsText
            ? _c("legal-mentions4x-cb", {
                attrs: {
                  label: _vm.cb4xLegalMentionsText,
                  "popin4x-cb": _vm.popin4xCb,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.generalLegalMentions
            ? _c("div", {
                staticClass: "small",
                domProps: { innerHTML: _vm._s(_vm.generalLegalMentions) },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }